import { render, staticRenderFns } from "./currencyInfo.vue?vue&type=template&id=6dd25f0c"
import script from "./currencyInfo.vue?vue&type=script&lang=js"
export * from "./currencyInfo.vue?vue&type=script&lang=js"
import style0 from "./currencyInfo.vue?vue&type=style&index=0&id=6dd25f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports